import { useRef } from "react";
import { Bug } from "lucide-react";
import { IconPill } from "../Universal/IconPill";
import { usePanels } from "../contexts/PanelsContext";

const PopUpTicket = ({ buttonNavbar = false, iconOnly = false }) => {
  const { isTicketsOpen, setIsTicketsOpen } = usePanels();
  const overlayRef = useRef(null);

  const toggleDropdown = () => {
    setIsTicketsOpen(!isTicketsOpen);
  };

  // VN icon button pattern (navbar icon-only usage)
  const iconBtnClasses = [
    "flex items-center justify-center w-8 h-8 rounded-lg",
    "border border-transparent bg-transparent",
    "text-mutedText transition hover:bg-mainButtonBg/50 hover:text-mainText",
    "outline-none ring-inputFocus/60 focus-visible:ring-2",
    "cursor-pointer",
  ].join(" ");

  const renderButton = () => {
    if (iconOnly) {
      return (
        <button
          type="button"
          onClick={toggleDropdown}
          className={iconBtnClasses}
          aria-label={
            isTicketsOpen ? "Close ticket window" : "Open ticket window"
          }
          aria-expanded={isTicketsOpen}
          title="Tickets"
        >
          <Bug
            strokeWidth={1.5}
            className={[
              "h-[18px] w-[18px] transition-colors duration-200",
              isTicketsOpen ? "text-velBlue" : "text-mutedText",
            ].join(" ")}
          />
        </button>
      );
    }

    if (buttonNavbar) {
      return (
        <IconPill size="md" onClick={toggleDropdown} aria-label="Create ticket">
          <Bug
            strokeWidth={1}
            className={[
              "h-5 w-5 shrink-0 transition-colors duration-200",
              isTicketsOpen ? "text-velBlue" : "text-mutedText/60",
            ].join(" ")}
          />
        </IconPill>
      );
    }

    // Sidebar full-width button
    return (
      <button
        type="button"
        onClick={toggleDropdown}
        aria-label={
          isTicketsOpen ? "Close ticket window" : "Open ticket window"
        }
        aria-expanded={isTicketsOpen}
        className={[
          "relative group w-full rounded-lg border px-4 py-2 transition-all duration-200 cursor-pointer",
          isTicketsOpen
            ? "bg-velBlue/15 border-velBlue/30"
            : "bg-transparent border-surfaceBorder hover:bg-btnHover hover:border-velBlueSecond/25",
        ].join(" ")}
      >
        <div className="relative z-10 flex items-center gap-x-3 min-h-[32px]">
          <Bug
            strokeWidth={1}
            className={[
              "h-5 w-5 shrink-0",
              isTicketsOpen ? "text-velBlue" : "text-mutedText/60",
            ].join(" ")}
          />
          <span
            className={[
              "truncate text-[15px] font-normal tracking-wide",
              isTicketsOpen ? "text-velBlue" : "text-mutedText",
            ].join(" ")}
          >
            Tickets
          </span>
        </div>
      </button>
    );
  };

  return (
    <div className="relative inline-block text-left text-base" ref={overlayRef}>
      {renderButton()}
    </div>
  );
};

export default PopUpTicket;
